import React from "react";
import { X } from "lucide-react";
import { cashDueForOrder } from "../lib/localErrands.js";
import ListingPublishForm from "./ListingPublishForm.jsx";
import RequestItemForm from "./RequestItemForm.jsx";

const dialogTitles = {
  trip: "Post a trip",
  errand: "Offer a local errand",
  request: "Request an item",
};

export default function MarketplaceActionDialog({
  dialogRef,
  type,
  errors,
  newTrip,
  newErrand,
  request,
  marketplaceToday,
  selectedOffer,
  selectedTrip,
  onClose,
  onTripFieldChange,
  onErrandFieldChange,
  onRequestFieldChange,
  onSubmitTrip,
  onSubmitErrand,
  onSubmitRequest,
}) {
  const cashEstimate =
    selectedOffer && Number(request.budget) > 0
      ? cashDueForOrder({
          budget: Number(request.budget),
          local_offer_id: selectedOffer.id,
          runner_fee: selectedOffer.runner_fee,
        })
      : null;

  return (
    <div className="overlay">
      <div
        ref={dialogRef}
        tabIndex="-1"
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="order-modal-title"
      >
        <button
          type="button"
          className="close"
          aria-label="Close dialog"
          onClick={onClose}
        >
          <X />
        </button>
        <h2 id="order-modal-title">{dialogTitles[type]}</h2>
        {type === "trip" ? (
          <ListingPublishForm
            type="trip"
            values={newTrip}
            errors={errors}
            marketplaceToday={marketplaceToday}
            onFieldChange={onTripFieldChange}
            onSubmit={onSubmitTrip}
          />
        ) : type === "errand" ? (
          <ListingPublishForm
            type="errand"
            values={newErrand}
            errors={errors}
            marketplaceToday={marketplaceToday}
            onFieldChange={onErrandFieldChange}
            onSubmit={onSubmitErrand}
          />
        ) : (
          <RequestItemForm
            values={request}
            errors={errors}
            offer={selectedOffer}
            trip={selectedTrip}
            cashEstimate={cashEstimate}
            onFieldChange={onRequestFieldChange}
            onSubmit={onSubmitRequest}
          />
        )}
      </div>
    </div>
  );
}
